import React, { useEffect, useRef, useState } from "react";
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/SurveyGeoJsonQuestion";

//react component start with capital letter
export default function Surveypage() {
  const id = window.location.pathname.replace("/", "");

  //TODO when the survey is done and it's submitted replace the whole page with a new html page will be loaded to say thank you
  const [message, setMessage] = useState(null);

  function handleResult(result) {
    //Inside the function, there's a switch statement based on the value of result.next_step.
    //This is a way to handle different cases or scenarios based on the value of next_step.
    switch (result.next_step) {
      //Case "redirect": If result.next_step is "redirect"
      //it means that the operation requires a redirection to another URL.
      case "redirect": {
        const text = "[Redirecting to another page.] " + result.message;
        toast.success(text);
        setMessage({ status: "success", text });
        setTimeout(() => {
          window.location.href = result.redirect_to; // Change to the actual URL
        }, 1000);
        //handle redirect
        break;
      }
      //Case "show_success_message": If result.next_step is "show_success_message",
      //it means that the operation was successful, and the code calls the function showMessage
      //with the arguments 'success' and 'Operation was successful!'
      case "show_success_message": {
        const text = "[Operation was successful!] " + result.message;
        toast.success(text);
        setMessage({ status: "success", text });
        //show the message 'success'
        break;
      }
      //Case "show_error_message": If result.next_step is "show_error_message",
      //it means that an error occurred during the operation. Similar to the previous case,
      //the code calls the function showMessage with the arguments 'error' and 'An error occurred.'.
      case "show_error_message": {
        const text = "[An error occurred.] " + result.message;
        toast.error(text);
        setMessage({ status: "error", text });
        break;
      }
      case "next_survey": {
        const text = "[Redirecting to another survey.] " + result.message;
        toast.success(text);
        document.title = result.survey_data.title || "Boomerang Survey";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", result.survey_data.description);
        const s = new Model({
          ...result.survey_data,
          logo: result.logo,
        });
        //we applied theme to survey
        s.applyTheme(result.theme);
        s.onComplete.add(surveyComplete);
        //set the state variable
        setSurvey(s);
        break;
      }
      default:
      //show message 'error'
    }
  }
  // Define an asynchronous function named postSurveyJson that takes 'data' as a parameter
  async function postSurveyJson(id, data) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      // Use the 'fetch' function to make an HTTP POST request to the specified URL
      const response = await fetch("/surveyData/" + id + "?tz=" + tz, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
          Authorization: token,
        },
        body: JSON.stringify(data), // Convert 'data' to a JSON string and set it as the request body
      });
      // At this point, the POST request has been sent and a response has been received
      // The response object contains information about the response from the server
      // You can process the response here (not shown in the provided code snippet)
      const result = await response.json();
      if (response.status === 200) {
        if (!data.partial && !data.deferResult) {
          handleResult(result);
        }
        return result;
      }

      toast.error(result.message);
      setMessage({ status: "error", text: result.message });
      return null;
    } catch (error) {
      // If an error occurs during the fetch or request handling, it will be caught here
      toast.error("There was a problem");
      setMessage({ status: "error", text: "There was a problem" });
      console.error("Error:", error);
    }
  }

  //create survey variable when it runs it's empty
  //this is state variable named survey and setSurvey is the fucntion that define the state variable
  const [survey, setSurvey] = useState();
  const [token, setToken] = useState(null);
  const [liveQuestions, setLiveQuestions] = useState([]);
  const [liveTrackingEnabled, setLiveTrackingEnabled] = useState({});
  const [showLiveLocationScreen, setShowLiveLocationScreen] = useState(false);
  const [deferredResult, setDeferredResult] = useState(null);
  const [liveLocationStatus, setLiveLocationStatus] = useState({});
  const liveLocationWatchIds = useRef({});
  const liveLocationIntervals = useRef({});
  const livePositions = useRef({});

  const submitLiveLocationUpdate = (event) => {
    const { questionId, value } = event.detail || {};
    if (!questionId || !value || !token) {
      return;
    }

    postSurveyJson(id, {
      partial: true,
      submittedQuestionUUIDs: [questionId],
      resultData: { [questionId]: [value.toString()] },
      files: {},
    });
  };

  useEffect(() => {
    window.addEventListener("boomerang:live-location-update", submitLiveLocationUpdate);
    return () =>
      window.removeEventListener(
        "boomerang:live-location-update",
        submitLiveLocationUpdate
      );
  }, [token]);

  const stopLiveLocationTracking = (questionId) => {
    if (liveLocationWatchIds.current[questionId] !== undefined) {
      navigator.geolocation.clearWatch(liveLocationWatchIds.current[questionId]);
      delete liveLocationWatchIds.current[questionId];
    }
    if (liveLocationIntervals.current[questionId]) {
      window.clearInterval(liveLocationIntervals.current[questionId]);
      delete liveLocationIntervals.current[questionId];
    }
    delete livePositions.current[questionId];
  };

  const submitTrackedLocation = (questionId) => {
    const position = livePositions.current[questionId];
    if (!position) {
      return;
    }

    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    const value = JSON.stringify({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [longitude, latitude],
      },
    });
    setLiveLocationStatus((current) => ({
      ...current,
      [questionId]: { latitude, longitude, updatedAt: new Date() },
    }));
    submitLiveLocationUpdate({ detail: { questionId, value } });
  };

  const toggleLiveLocationTracking = (
    question,
    enabled = !liveTrackingEnabled[question.name]
  ) => {
    const questionId = question.name;

    if (!enabled) {
      stopLiveLocationTracking(questionId);
      setLiveTrackingEnabled((current) => ({ ...current, [questionId]: false }));
      return;
    }

    if (!navigator.geolocation) {
      toast.error("Location is not supported by this browser.");
      return;
    }

    const intervalMs = Math.max(1, Number(question.liveUpdateInterval) || 60) * 1000;
    const geolocationOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    };
    const updatePosition = (position) => {
      livePositions.current[questionId] = position;
      submitTrackedLocation(questionId);
    };
    const onLocationError = () =>
      toast.error(`Could not get location for ${question.title || "this question"}.`);

    // Obtain a location immediately so the map can render before the first interval.
    navigator.geolocation.getCurrentPosition(
      updatePosition,
      onLocationError,
      geolocationOptions
    );
    liveLocationWatchIds.current[questionId] = navigator.geolocation.watchPosition(
      (position) => {
        livePositions.current[questionId] = position;
      },
      onLocationError,
      geolocationOptions
    );
    liveLocationIntervals.current[questionId] = window.setInterval(
      () => submitTrackedLocation(questionId),
      intervalMs
    );
    setLiveTrackingEnabled((current) => ({ ...current, [questionId]: true }));
  };

  const continueAfterLiveLocation = () => {
    Object.keys(liveLocationWatchIds.current).forEach(stopLiveLocationTracking);
    setShowLiveLocationScreen(false);
    if (deferredResult) {
      handleResult(deferredResult);
      setDeferredResult(null);
    }
  };

  useEffect(() => () => {
    Object.keys(liveLocationWatchIds.current).forEach(stopLiveLocationTracking);
  }, []);

  const surveyComplete = (sender) => {
    Object.keys(liveLocationWatchIds.current).forEach(stopLiveLocationTracking);
    const files = {};
    //add a function to send this back to the server
    const resultData = {};
    for (const key in sender.data) {
      const question = sender.getQuestionByName(key);
      if (!question) {
        continue;
      }
      const questionType = question.getType();
      if (typeof question.value === "object") {
        if (questionType === "file") {
          files[key] = question.value;
        } else {
          resultData[key] = question.value;
        }
      } else {
        if (questionType === "signaturepad") {
          // signature is a file
          // but survey returns it as text response
          files[key] = [
            {
              content: question.value,
              name: "signature_" + key + "_" + Date.now() + ".png",
              type: "image/png",
            },
          ];
        } else if (questionType === "geo-json") {
          resultData[key] = [question.value.toString()];
        } else {
          resultData[key] = [question.value.toString()];
        }
      }
    }
    const questions = sender
      .getAllQuestions()
      .filter(
        (question) =>
          question.getType() === "geo-json" &&
          String(question.liveUpdate).toLowerCase() === "true" &&
          question.getPropertyValue("liveLocationConsent") === true
      )
      .map((question) => ({
        name: question.name,
        title: question.title,
        liveUpdateInterval: question.liveUpdateInterval,
      }));
    const finalSubmission = {
      resultData,
      files,
      submittedQuestionUUIDs: [...new Set([...Object.keys(resultData), ...Object.keys(files)])],
    };

    postSurveyJson(window.location.pathname.replace("/", ""), {
      ...finalSubmission,
      deferResult: questions.length > 0,
    }).then((result) => {
      if (!result || questions.length === 0) {
        return;
      }

      setDeferredResult(result);
      setLiveQuestions(questions);
      setLiveTrackingEnabled(
        questions.reduce((enabled, question) => ({
          ...enabled,
          [question.name]: true,
        }), {})
      );
      setLiveLocationStatus({});
      setShowLiveLocationScreen(true);
      questions.forEach((question) => toggleLiveLocationTracking(question, true));
    });
    // console.log(sender, sender.data)
  };
  //get data from server
  async function getSurveyData(id) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await fetch("/surveyData/" + id + "?tz=" + tz, {
        method: "GET",
        headers: {
          Authorization: token,
        },
      });
      const data = await response.json();

      if (response.status === 200) {
        //geetting data from server (survey variable)
        if (data.survey_data) {
          document.title = data.survey_data.title || "Boomerang Survey";
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", data.survey_data.description);
          const s = new Model({
            ...data.survey_data,
            logo: data.logo,
          });
          //we applied theme to survey
          s.applyTheme(data.theme);
          s.onComplete.add(surveyComplete);
          //set the state variable
          setSurvey(s);
        }
        if (data.next_step === "show_error_message") {
          setMessage({ status: "error", text: data.message });
        }
      } else {
        toast.error(data.message);
        setMessage({ status: "error", text: data.message });
      }
    } catch (error) {
      toast.error("An error occurred.", error);
    }
  }

  //runs once only the initial data
  useEffect(() => {
    if (token) {
      getSurveyData(id);
    }
  }, [token]);

  const getToken = (surveyId) =>
    fetch("/token/" + surveyId)
      .then((res) => res.json())
      .then((data) => setToken(data));

  useEffect(() => {
    if (id) {
      getToken(id);
    }
  }, [id]);

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {message && <div className={message?.status}>{message?.text}</div>}
      {showLiveLocationScreen ? (
        <main className="live-location-screen">
          <h1>Live location updates</h1>
          <p>Choose which locations to share while this survey remains open.</p>
          <div className="live-location-screen__questions">
            {liveQuestions.map((question) => (
              <label key={question.name} className="live-location-screen__question">
                <span>
                  <strong>{question.title || "Location"}</strong>
                  <small>Updates every {question.liveUpdateInterval || 60} seconds.</small>
                  <span className="live-location-screen__toggle">
                    <input
                      type="checkbox"
                      checked={Boolean(liveTrackingEnabled[question.name])}
                      onChange={() => toggleLiveLocationTracking(question)}
                    />
                    Enable live location updates
                  </span>
                  {liveLocationStatus[question.name] ? (
                    <>
                      <img
                        className="live-location-screen__map"
                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${liveLocationStatus[question.name].latitude},${liveLocationStatus[question.name].longitude}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7C${liveLocationStatus[question.name].latitude},${liveLocationStatus[question.name].longitude}&key=${encodeURIComponent(window.GM_API_KEY || "")}`}
                        alt={`Last known location for ${question.title || "location"}`}
                      />
                      <small>
                        Updated at {liveLocationStatus[question.name].updatedAt.toLocaleTimeString()}.
                      </small>
                    </>
                  ) : (
                    <small>Waiting for the first location update.</small>
                  )}
                </span>
              </label>
            ))}
          </div>
          <button
            type="button"
            className="sd-btn sd-btn--action"
            onClick={continueAfterLiveLocation}
          >
            {Object.values(liveTrackingEnabled).some(Boolean) ? "Continue" : "Skip"}
          </button>
        </main>
      ) : survey ? (
        <Survey className="height-fix" model={survey} />
      ) : (
        <div className="height-fix" />
      )}
      <footer className="page-copyright">
        <p>
          <strong>Boomerang Messaging Services</strong> &copy; 2010 - 2023
          Boomerang I-comms Ltd, trading as Boomerang. Registered in England
          &amp; Wales number 08217876. ISO27001 certified
        </p>
        <a
          href="https://boomerangmessaging.com/privacy-policy/"
          target="_blank"
        >
          Privacy Policy
        </a>{" "}
        |{" "}
        <a href="https://boomerangmessaging.com/cookie-policy/" target="_blank">
          Cookie Policy
        </a>
      </footer>
      <ToastContainer />
    </div>
  );
}
